import {Component, input} from '@angular/core';

@Component({
  selector: 'app-counter-badge',
  imports: [],
  templateUrl: './counter-badge.html',
  styleUrl: './counter-badge.css',
})
export class CounterBadge {
  value = input<number>(0);
}
